import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Space, Dropdown, Badge } from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { GET_MY_SCOPE_TYPES } from '../../gql/auth';
import { containsOneOf } from '../../utils';
import './TopNav.less';
import { SelectUserRoleModal } from 'components/auth';
import { useCountPendingApprovals } from 'hooks';
import { SCOPE_TYPES } from 'constants/scopes';
// import NoticeIcon from './NoticeIcon/NoticeIcon';

const { Header } = Layout;

const TopNav = () => {
  const { pathname } = useLocation();
  const { data, loading } = useQuery(GET_MY_SCOPE_TYPES);
  const { count } = useCountPendingApprovals();
  const pathNames = pathname.split('/');
  const projectId = pathNames[1] === 'projects' ? pathNames[2] : null;

  const navs = [
    {
      key: 'home',
      to: '/home',
      text: 'Home',
    },
    {
      key: 'projects',
      to: '/projects',
      text: 'Projects',
    },
    {
      expectedScopeType: [
        'VIEW_EXTENSION',
        'VIEW_VIREMENT',
        'VIEW_WITHDRAWAL',
        'VIEW_PROPOSAL_REVISION',
      ],
      key: 'pending-approvals',
      to: '/pending-approvals#extensions',
      text: (
        <Badge
          // size="small"
          count={count?.total > 0 ? count?.total : 0}
          offset={[12, -4]}
          className="ant-badge-count-primary"
        >
          Pending Approvals
        </Badge>
      ),
    },
    {
      key: 'annual-reports',
      to: '/annual-reports#reports',
      text: 'F/SLTC Annual Reports',
      expectedScopeType: [
        SCOPE_TYPES.WRITE_ANNUAL_REPORT,
        SCOPE_TYPES.WRITE_ANNUAL_REPORT_WITH_CUSTOM_DATE,
        SCOPE_TYPES.VIEW_ANNUAL_REPORT,
        SCOPE_TYPES.VIEW_ALL_ANNUAL_REPORT,
        SCOPE_TYPES.VIEW_ANNUAL_REPORT_PROJECT,
      ],
    },
    {
      key: 'project-applications',
      to: '/project-applications/fundings',
      text: 'Funding Applications',
    },
    {
      key: 'other-reports',
      to: '/other-reports',
      text: 'Other Reports',
      expectedScopeType: [SCOPE_TYPES.VIEW_OTHER_REPORTS],
    },
    {
      expectedScopeType: ['WRITE_ROLE'],
      key: 'system-setting',
      to: '/system-setting/dashboard',
      text: 'System Setting',
    },
  ];

  const menu = (
    <Menu style={{ minWidth: '150px' }} className="nav-right-menu">
      <Menu.Item key="user-profile" icon={<UserOutlined />}>
        <Link to="/user-profile">User Profile</Link>
      </Menu.Item>
      <Menu.Item key="switch-user-role" icon={<UserSwitchOutlined />}>
        <SelectUserRoleModal
          canHide={true}
          visible={false}
          showButton={true}
          projectId={projectId}
        />
      </Menu.Item>
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        <Link to="/logout">Logout</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    !loading && (
      <Header>
        <Space size="middle" style={{ float: 'right' }}>
          {/* TODO: Add notification */}
          {/* <NoticeIcon /> */}
          <Dropdown overlay={menu} trigger={['click']}>
            <Button type="primary" shape="circle" icon={<UserOutlined />} />
          </Dropdown>
        </Space>
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[pathname.split('/')[1]]}
        >
          {navs.map(({ key, to, text, expectedScopeType }) =>
            expectedScopeType ? (
              containsOneOf(expectedScopeType)(data?.myScopeTypes) && (
                <Menu.Item key={key}>
                  <Link to={to}>{text}</Link>
                </Menu.Item>
              )
            ) : (
              <Menu.Item key={key}>
                <Link to={to}>{text}</Link>
              </Menu.Item>
            )
          )}
        </Menu>
      </Header>
    )
  );
};

export default TopNav;
